// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"73018c54","116":"4f2dcedb","191":"35b97252","374":"29d83f37","584":"0d510ce0","659":"1b082c6e","730":"020dedb5","912":"9245b5a3"}[chunkId] + ".chunk.css";
};